import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import { useTheme } from "../DataContext";
import { buildGlobalStyles, getThemeNames } from "../theme";

export default function PageLayout({ children, title, subtitle, actions }) {
  const { theme, themeName, setTheme } = useTheme();
  const allThemes = getThemeNames();

  useEffect(() => {
    let styleEl = document.getElementById("pmo-global-styles");
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = "pmo-global-styles";
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = buildGlobalStyles(theme);
  }, [theme]);

  return (
    <div style={{
      display: "flex", height: "100vh", overflow: "hidden",
      background: theme.bg,
    }}>
      {/* Fixed theme selector — always visible top-right */}
      <select
        value={themeName}
        onChange={e => { setTheme(e.target.value); window.location.reload(); }}
        style={{
          position: "fixed", top: "14px", right: "20px", zIndex: 9999,
          width: "148px", padding: "7px 10px",
          background: theme.card,
          border: `1px solid ${theme.accent}55`,
          borderRadius: "8px",
          color: theme.textSecondary,
          fontFamily: "'Share Tech Mono', monospace",
          fontSize: "10px", letterSpacing: "1px",
          cursor: "pointer", outline: "none",
        }}
      >
        {allThemes.map(t => (
          <option key={t.key} value={t.key}>{t.name}</option>
        ))}
      </select>

      <Sidebar />
      <main style={{
        flex: 1, overflow: "auto",
        display: "flex", flexDirection: "column",
      }}>
        {/* Topbar */}
        <div style={{
          padding: "18px 28px",
          background: `linear-gradient(90deg, ${theme.card}, ${theme.bg})`,
          borderBottom: `1px solid ${theme.cardBorder}`,
          display: "flex", alignItems: "center", justifyContent: "space-between",
          flexShrink: 0,
        }}>
          <div style={{ minWidth: 0, flex: 1 }}>
            {title && (
              <h1 style={{
                fontFamily: "'Orbitron', monospace",
                fontSize: "16px", fontWeight: 700,
                color: theme.textPrimary, letterSpacing: "1px",
                display: "flex", alignItems: "center", gap: "10px",
              }}>
                <span style={{ color: theme.accent }}>✦</span>
                {title}
              </h1>
            )}
            {subtitle && (
              <div style={{
                fontSize: "12px", color: theme.textMuted,
                marginTop: "3px", letterSpacing: "0.3px",
              }}>{subtitle}</div>
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0, paddingRight: "168px" }}>
            {actions}
          </div>
        </div>

        {/* Page Content */}
        <div style={{ flex: 1, overflow: "auto", padding: "20px 28px" }}>
          {children}
        </div>
      </main>
    </div>
  );
}
